import { Injectable } from '@angular/core';
import { PromoApi } from '@kp/shared/components/promo/promo.api';
import { Promo } from '@kp/shared/components/promo/promo.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PromoBloc {
  constructor(private _promoApi: PromoApi) {}

  private _promosSubject$ = new BehaviorSubject<Promo[]>(null);
  private _featuredPromoHadOpportunity = false;

  get promosSubject$(): Observable<Promo[]> {
    return this._promosSubject$.asObservable();
  }

  getPromos(): void {
    this._promoApi
      .getPromos()
      .then((promos) => {
        // continue to mark all featured promos as shownAsFeatured if there's already been
        // an opportunity to display as a modal per _featuredPromoHadOpportunity until app is refreshed
        const normalizedPromos = this._featuredPromoHadOpportunity
          ? promos.map((promo) => {
              if (promo?.featuredForToday) {
                promo.shownAsFeatured = true;
              }
              return promo;
            })
          : promos;
        this._promosSubject$.next(normalizedPromos);
      })
      .catch((error) => {
        console.warn(`There was an error getting promos: `, error);
        this._promosSubject$.next(null);
      });
  }

  removePromo(promoId: string) {
    this._promosSubject$.next(this._promosSubject$.getValue()?.filter((promo) => promo.id !== promoId));
  }

  preventFeaturePromoModal() {
    this._featuredPromoHadOpportunity = true;
  }
}
